<template>
    <transition name="modal">
        <div>
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('close')">
                    <div class="modal-container" @click.stop="">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content" :class='{isTpg: isTpg}'>
                                <div class="modal-title" style="margin-bottom:30px;">
                                    <p>{{msg}}</p>
                                    <div class="close-modal" @click="$emit('close')" :class='{isTpg: isTpg}'>
                                        <font-awesome-icon icon="times" aria-hidden="false" />
                                    </div>
                                </div>
                                <div class="">

                                    <button class="confirmButton" @click="confirm">Confirm</button>

                                    <button class="confirmButton" @click="cancel">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import $ from 'jquery';

export default {
  props: ['msg', 'isTpg'],
  methods: {
    confirm() {
      this.$emit('confirm');
      this.$emit('close');
    },
    cancel() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-dialog {
    width: auto;
    max-width: 700px;
    margin: 0 auto;
    margin-top: 50px;
}
button {
    margin-bottom: 10px;
}
.modal-content {
    /* width:700px;
        margin:0 auto; */
    background: #fff;
    color: black;
    padding-bottom: 20px;
}

.modal-content.isTpg {
    background-color: #efefef;
    color: #3a3a3a;
}

.close-modal {
    position: absolute;
    top: 0px;
    right: 10px;
    cursor: pointer;
    text-align: right;
    width: 20px;
    height: 20px;
    color: black;
}

</style>
